import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { getConsistencyCheckBranchesExport } from '@api/consistencyCheck';

import { IDumpId } from '@interfaces/cmModule/dto/cmModuleDTO';

import { ESnackbarTypes } from '@enums/common';

import { CONSISTENCY_BRANCHES_EXPORT } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

const useMutateConsistencyCheckBranchesExport = () => {
	const dispatch = useAppDispatch();

	const {
		mutate: handleConsistencyCheckBranchesExport,
		isLoading: isLoadingConsistencyCheckBranchesExport,
	} = useMutation<IDumpId>({
		mutationKey: [CONSISTENCY_BRANCHES_EXPORT],
		mutationFn: getConsistencyCheckBranchesExport,
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.exportStartingSuccess,
				type: ESnackbarTypes.success,
			}));
		},
	});

	return {
		handleConsistencyCheckBranchesExport,
		isLoadingConsistencyCheckBranchesExport,
	};
};

export default useMutateConsistencyCheckBranchesExport;
